<template>
  <div>
    <tree-select
      ref="treeSelect"
      :props="props"
      :options="data"
      :value="value1"
      :clearable="true"
      :accordion="true"
      :parent-select="parent"
      style="width:100%"
      @node-select="onTreeSelect($event)"
    />
  </div>
</template>
<script>
import treeSelect from "@/components/common/treeSelect";
export default {
  components: {
    treeSelect,
  },
  props: {
    value: {},
    parent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: [],
      value1: this.value,
      props: {
        // 配置项（必选）
        value: "MallClassId",
        label: "MallClassName",
        children: "children",
        // disabled:true
      },
      api: require("@/api/mall/mallclass").default,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.api.list({}).then((res) => {
        this.value1 = this.value;
        this.data = this.$commonJs.toTreeData(res.Data, "MallClassId");
        this.$refs.treeSelect.setData();
      });
    },
    onTreeSelect(value) {
      var id = value ? value["MallClassId"] : null;
      // 
      this.$emit("input", id);
    },
    clear() {
      this.data = [];
      this.$refs.treeSelect.clearHandle();
    },
  },
};
</script>